module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "rentalsummarytable",
      "title": "Rentals/Lease",
      "icon": "fa fa-hand-holding-usd",
      "search-placeholder": "Site name, Landlord",
      "url": "/report/property/rentals/summary",
      "fields": _vm.fields
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e059292"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/property/PropertyRentalSummary.vue
// module id = 1593
// module chunks = 0